import React, { useState } from 'react';
import './Highlights.css';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa'; // Icon import
import logo from '../../assets/images/logo1.png'; 

const Highlights = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState(""); // Form status

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setResult("");
  };

  // Web3Forms Submit Logic
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    // Using your provided Access Key
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");
    formData.append("subject", "New Brochure Request - Highlights Section");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Brochure Request Sent!");
      event.target.reset();
      setTimeout(() => {
        closeModal();
      }, 2500);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  const data = [
    "14-Storey Residential Landmark",
    "Premium 2, 2.5 & 3 BHK homes",
    "Over 20+ Lifestyle Amenities",
    "Quality Construction and Modern Architecture",
    "Prime location within Moshi, PCMC",
    "Trusted Brand - Sentosa Developers"
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { y: 40, opacity: 0 },
    visible: { 
      y: 0, 
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section id="highlights" className="highlights-section">
      <div className="highlights-container">
        
        <motion.div 
          className="highlights-header"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 0.8 }}
        >
          <div className="line"></div>
          <h2 className="highlights-title">Key Highlights</h2>
          <div className="line"></div>
        </motion.div>

        <motion.div 
          className="highlights-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
        >
          {data.map((item, index) => (
            <motion.div key={index} className="highlight-card" variants={itemVariants}>
              <span className="arrow-icon">»</span>
              <p>{item}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          className="cta-banner-section"
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.8 }}
        >
          <div className="cta-overlay">
            <h2 className="cta-title">Don't Miss Out On Your Lifestyle Upgrade</h2>
            <a href="tel:9371320616" className="cta-phone-pill">
              <span className="phone-icon-svg">📞</span> 9371320616
            </a>
          </div>
        </motion.div>

        <motion.div 
          className="highlights-footer"
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <button className="brochure-btn" onClick={openModal}>Request Brochure</button>
        </motion.div>
      </div>

      {/* --- UPDATED FORM MODAL --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            
            <div className="modal-content">
              <div className="modal-logo">
                <img src={logo} alt="Logo" />
              </div>
              <h2 className="enquire-title">Enquire Now</h2>
              
              <form className="modal-form" onSubmit={onSubmit}>
                <input type="text" name="first_name" placeholder="First Name" required />
                <input type="text" name="last_name" placeholder="Last Name" required />
                <input type="email" name="email" placeholder="Email Id" required />
                <input type="tel" name="mobile" placeholder="Mobile No." required />
                
                {/* <select name="project" required className="modal-select">
                  <option value="" disabled selected>Select Project</option>
                  <option value="Sentosa Era">Sentosa Era</option>
                </select> */}

                <div className="checkbox-container">
                  <input type="checkbox" id="high-consent" name="consent" required />
                  <label htmlFor="high-consent">
                    I hereby authorize to send notification on SMS, Calls, RCS, WhatsApp.
                  </label>
                </div>

                <button type="submit" className="modal-submit-btn">
                  SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
                </button>
              </form>

              {result && <p className="form-status">{result}</p>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Highlights;